var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('HospitalHeader'),_c('div',{staticClass:"home"},[_c('Calendar')],1),_c('ManagementFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }